export default "__VITE_ASSET__Bjh6B$FC__"